/**
 * HM-386 cluster login PIN: card singolo operatore per griglia Step 1.
 * Avatar circle colored by role (admin marroncino / reception arancio Hotel Mik).
 * Click -> onSelect(operator) propaga lo state in LoginPage orchestratore.
 */
import type { Operator } from '../../api/auth.js';

const ROLE_LABEL: Record<Operator['role'], string> = {
  admin: 'Admin',
  reception: 'Reception',
  housekeeping: 'Housekeeping',
  owner: 'Owner',
};

export function OperatorCard({
  operator,
  onSelect,
}: {
  operator: Operator;
  onSelect: (operator: Operator) => void;
}) {
  const role = operator.role;
  const isAdminLike = role === 'admin' || role === 'owner';
  const avatarClass = `operator-avatar ${isAdminLike ? 'admin' : 'reception'}`;
  const roleClass = `operator-role ${isAdminLike ? 'admin' : 'reception'}`;
  return (
    <button
      type="button"
      className="operator-card"
      onClick={() => onSelect(operator)}
      aria-label={`Seleziona operatore ${operator.displayName}`}
      data-testid={`operator-card-${operator.username}`}
    >
      <div className={avatarClass}>{operator.initials}</div>
      <div>
        <div className="operator-name">{operator.displayName}</div>
        <div className={roleClass}>{ROLE_LABEL[role] ?? role}</div>
      </div>
    </button>
  );
}
